<template>
  <router-view />
</template>
<script>
export default {
  name: 'Messagecenterone',
  data() {
    return {

    }
  },
  created() {
    const route = this.$route.matched.find(item => item.name === 'Messagecenterone')
    this.$store.dispatch('tagsView/addCachedView', route)
  }
}
</script>
